import core from "./core.json"
import common from "./common.json"
import orders from "./orders.json"
import maps from "./maps.json"
import planOrder from "./planOrder.json"
import fleet from "./fleet.json"
import planner from "./planner.json"
import chat from "./chat.json"
import ai from "./ai.json"
import reports from "./reports.json"
import app from "./app.json"

// One file per area, so parallel work on different screens never edits the
// same file. `core` keeps the first screens' keys at the top level.
const bundle = {
  ...core,
  common,
  orders,
  maps,
  planOrder,
  fleet,
  planner,
  chat,
  ai,
  reports,
  app,
}

export default bundle
